module.exports = __webpack_public_path__ + "static/img/login_bg.3ad4d34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/yyk/login_bg.jpg
// module id = 399
// module chunks = 0